module.exports = __webpack_public_path__ + "img/indomaret-light.28dfb93a.png";